const version = '0.0.1'

export default version
